import styled from '@emotion/styled'

import { breakpoints, palette, spacing, Text, typography } from 'main/ui'

export const Container = styled.div<{ reverse: boolean }>`
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
  justify-content: space-evenly;
  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(8)}px;
  }
  @media (max-width: ${breakpoints.lg}px) {
    flex-direction: column;
    align-items: center;
    padding: 0 ${spacing.majorScale(3)}px;
    > :not(:last-child) {
      margin-bottom: ${spacing.majorScale(5)}px;
    }
  }
`

export const ImageContainer = styled.div<{ bgColor: string }>`
  display: flex;
  background-color: ${({ bgColor }) => bgColor};
  height: 540px;
  width: 540px;
  justify-content: center;
  border-radius: 8px;
  @media (max-width: ${breakpoints.lg}px) {
    height: 335px;
    width: 335px;
  }
`

export const AppImage = styled.img`
  align-self: flex-end;
  border-radius: ${spacing.majorScale(1)}px ${spacing.majorScale(1)}px 0px 0px;
  @media (max-width: ${breakpoints.lg}px) {
    height: 300px;
  }
`

export const FeatureDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: ${breakpoints.lg}px) {
    justify-content: flex-start;
  }
`

export const FeatureTitle = styled(Text)`
  font-size: ${typography.fontSize.title.normal};
  font-weight: ${typography.fontWeight.bold};
  color: ${palette.black};
  margin-bottom: ${spacing.majorScale(4)}px;
`

export const FeatureDescription = styled(Text)`
  margin-bottom: ${spacing.majorScale(3)}px;
  max-width: 444px;
`
